import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

/**
 * Fetches booking slots that are ready for contribution generation.
 * @param {object} filters - Pagination and search filters.
 * @param {function} callback - The function to call with the response.
 */
export const getPendingSlots = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/contributions/slots', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Creates a new set of contributions for a specific booking slot.
 * @param {number} slotId - The ID of the booking slot.
 * @param {Array} playersData - The array of player contribution data.
 * @param {function} callback - The function to call with the response.
 */
export const createContributionsForSlot = async (slotId, playersData, callback) => {
    try {
        const payload = { players: playersData };
        const response = await risapi.post(`/api/booking-slots/${slotId}/contributions`, payload, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches the existing contributions for a specific booking slot (for editing).
 * @param {number} slotId - The ID of the booking slot.
 * @param {function} callback - The function to call with the response.
 */
export const fetchContributionsForSlot = async (slotId, callback) => {
    try {
        const response = await risapi.get(`/api/booking-slots/${slotId}/contributions`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Updates (regenerates) the contributions for a specific booking slot.
 * @param {number} slotId - The ID of the booking slot.
 * @param {Array} playersData - The updated array of player contribution data.
 * @param {function} callback - The function to call with the response.
 */
export const updateContributionsForSlot = async (slotId, playersData, callback) => {
    try {
        const payload = { players: playersData };
        const response = await risapi.put(`/api/booking-slots/${slotId}/contributions`, payload, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Deletes all contributions for a specific booking slot.
 * @param {number} slotId - The ID of the booking slot.
 * @param {function} callback - The function to call with the response.
 */
export const destroyContributionsForSlot = async (slotId, callback) => {
    try {
        const response = await risapi.delete(`/api/booking-slots/${slotId}/contributions`, getAxiosConfig());
        if (response.status === 204) {
            callback({ success: true }); // Indicate success
        }
    } catch (error) {
        callback(error);
    }
};



/**
 * Fetches the data required for a game slot statement.
 * @param {number} slotId - The ID of the booking slot.
 * @param {function} callback - The function to call with the response.
 */
export const getGameSlotStatement = async (slotId, callback) => {
    try {
        const response = await risapi.get(`/api/booking-slots/${slotId}/contributions/statement`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};
